import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="h1" components={components}>{`Getting Started`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`npm i rebass
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Import components directly from Rebass and use them to build out your UI.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-js"
        }}>{`import {
  Box,
  Card,
  Image,
  Heading,
  Text
} from 'rebass'
`}</MDXTag></MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-.jsx"
        }}>{`<Box width={256}>
  <Card
    p={1}
    borderRadius={2}
    boxShadow='0 0 16px rgba(0, 0, 0, .25)'>
    <Image src={photo} />
    <Box px={2}>
      <Heading as='h3'>
        Card
      </Heading>
      <Text fontSize={0}>
        Small meta text
      </Text>
    </Box>
  </Card>
</Box>
`}</MDXTag></MDXTag>
      <MDXTag name="h2" components={components}>{`Props`}</MDXTag>
      <MDXTag name="p" components={components}>{`Rebass components use `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://github.com/jxnblk/styled-system"
        }}>{`styled-system`}</MDXTag>{` for responsive, theme-based style props.`}</MDXTag>
      <MDXTag name="p" components={components}>{`Read more about `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "/props"
        }}>{`Rebass props`}</MDXTag>{`.`}</MDXTag>
      <MDXTag name="h2" components={components}>{`Extending`}</MDXTag>
      <MDXTag name="p" components={components}>{`Rebass components are also a great starting point for extending into custom UI components`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-jsx"
        }}>{`import styled from 'styled-components'
import { Button as Base } from 'rebass'

export const Button = styled(Base)\`
  border-radius: 9999px;
  &:hover {
    background-color: \${props => props.theme.colors.navy};
  }
\`
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Read more about `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "/extending"
        }}>{`Extending Rebass components`}</MDXTag>{`.`}</MDXTag>
      <MDXTag name="h2" components={components}>{`Theming`}</MDXTag>
      <MDXTag name="p" components={components}>{`Use a ThemeProvider component to completely customize the look and feel of Rebass components,
from fonts, font sizes, and colors to button variants and card styles.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-jsx"
        }}>{`import React from 'react'
import { ThemeProvider } from 'styled-components'

const blue = '#07c'
const lightgray = '#f6f6ff'

const theme = {
  fontSizes: [
    12, 14, 16, 24, 32, 48, 64
  ],
  colors: {
    blue,
    lightgray,
  },
  buttons: {
    primary: {
      color: '#fff',
      backgroundColor: blue,
    },
    outline: {
      color: blue,
      backgroundColor: 'transparent',
      boxShadow: 'inset 0 0 2px'
    },
  },
}

export default props =>
  <ThemeProvider theme={theme}>
    {props.children}
  </ThemeProvider>
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Read more about `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "/theming"
        }}>{`Theming Rebass components`}</MDXTag>{`.`}</MDXTag>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      